import { Link } from 'react-router-dom';
import { topics } from '@/mocks/community';

const covers = [
  'https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20fierce%20characters%20in%20a%20dynamic%20battle%20pose%20with%20glowing%20embers%20and%20energy%20effects%2C%20warm%20red%20and%20orange%20palette%2C%20dramatic%20action%20scene%2C%20flat%20vibrant%20anime%20art%20style%2C%20epic%20and%20intense%20mood%2C%20clean%20composition%20with%20soft%20light%20particles&width=800&height=600&seq=topic-battle&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20peaceful%20countryside%20at%20dusk%2C%20quiet%20scenery%20with%20warm%20light%20and%20a%20character%20sitting%20alone%20under%20a%20tree%2C%20soft%20pastel%20peach%20and%20amber%20tones%2C%20healing%20and%20gentle%20mood%2C%20flat%20anime%20art%20style%2C%20calm%20and%20comforting%20atmosphere%2C%20clean%20composition&width=800&height=600&seq=topic-heal&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20cheerful%20character%20holding%20a%20book%20beside%20a%20blooming%20cherry%20tree%2C%20warm%20spring%20light%2C%20coral%20and%20soft%20green%20palette%2C%20cozy%20reading%20atmosphere%2C%20flat%20vibrant%20anime%20art%20style%2C%20fresh%20and%20optimistic%20mood%2C%20clean%20composition%20with%20floating%20petals&width=800&height=600&seq=topic-news&orientation=squarish',
];

export default function TopicsSection() {
  return (
    <section className="bg-background-100/60">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex items-end justify-between gap-4">
          <div>
            <span className="text-xs font-semibold tracking-widest text-primary-600">SPECIAL TOPICS</span>
            <h2 className="mt-1 font-heading text-2xl md:text-3xl">值得一读的专题</h2>
          </div>
          <Link
            to="/topics"
            className="inline-flex whitespace-nowrap items-center gap-1 text-sm font-semibold text-primary-700 hover:text-primary-800"
          >
            全部专题 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-3">
          {topics.map((t, idx) => (
            <Link
              key={t.id}
              to="/topics"
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={covers[idx]}
                  alt={t.title}
                  className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 text-xs font-semibold text-primary-700">
                  {t.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="line-clamp-2 text-sm md:text-base font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                  {t.title}
                </h3>
                <p className="mt-2 flex-1 line-clamp-2 text-xs md:text-sm text-foreground-600">{t.summary}</p>
                <div className="mt-4 flex items-center gap-4 border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span><i className="ri-eye-line mr-0.5"></i>{t.reads.toLocaleString()}</span>
                  <span>{t.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}